import { SheedActiveProductModel } from "../../../admin/models/sheedActiveProductModel";

export class ResellerInfoModel {
    name: string;
    lastName: string;
    phoneNumber: string;
    userStatus: number;
    emailConfirmed: boolean;
    shop: string;
    zipCode: string;
    url: string;
    address: string;
    email: string;
    resellerType: number;
    nationalCardFile: any;
    contractFile: any;
    lastUpdateTime: Date;
    directoryId: number;
    getSaleTooltip() {
        return `فروش ${this.allUsedPackagesCount} از ${this.allPurchasedPackagesCount}`;
    }
    product:SheedActiveProductModel;
    allUsedPackagesCount: number;
    allPurchasedPackagesCount: number;
    isBulk:boolean;
}